module.exports = __webpack_public_path__ + "static/media/BoundWorx_Data_Sheet.3df83306.pdf";